import { API, graphqlOperation } from "aws-amplify";
import * as mutations from "../graphql/mutations/apiKeys";
import * as queries from "../graphql/queries/apiKeys";

class ApiKeysAPI implements IApiKeysAPI {
  async adminListApiKeys() {
    try {
      const response: any = await API.graphql(graphqlOperation(queries.adminListApiKeys, {}));
      const apiKeys = response.data.adminListApiKeys as IApiKey[];

      return apiKeys;
    } catch (e) {
      throw e;
    }
  }

  async adminGetApiKey(keyId: string) {
    try {
      const response: any = await API.graphql(graphqlOperation(queries.adminGetApiKey, { keyId }));
      return response.data.adminGetApiKey as IApiKey;
    } catch (e) {
      throw e;
    }
  }

  async adminUpdateApiKey(apiKey: IApiKeyUpdateInput) {
    try {
      const response: any = await API.graphql(
        graphqlOperation(mutations.adminUpdateApiKey, { input: apiKey })
      );
      return response.data.adminUpdateApiKey as IApiKey;
    } catch (e) {
      throw e;
    }
  }

  async adminCreateApiKey(apiKey: IApiKeyCreateInput) {
    try {
      const response: any = await API.graphql(
        graphqlOperation(mutations.adminCreateApiKey, { input: apiKey })
      );
      return response.data.adminCreateApiKey as IApiKey;
    } catch (e) {
      throw e;
    }
  }

  async adminDeleteApiKey(keyId: string) {
    try {
      const response: any = await API.graphql(
        graphqlOperation(mutations.adminDeleteApiKey, { keyId })
      );
      return response.data.adminDeleteApiKey as IApiKey;
    } catch (e) {
      throw e;
    }
  }
}

export default new ApiKeysAPI();
